<p class="title">Se está partiendo la operación de la siguiente manera</p>
<lib-partial-payment-confirmation-template
  [dividedInvoices]="entity?.dividedInvoices"
  [originalInvoice]="entity?.originalInvoice"
  [investors]="entity?.investors"
  [invoice]="entity?.invoice"
></lib-partial-payment-confirmation-template>
